
import vFooter from '../common/footer.vue'
import $ from 'jquery'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {index,shareTaskIndexList} from '@/base/js/api'

const news = ['恭贺 舌尖上的蚂蚁获得 300.00元奖励','恭贺 舌尖上的蚂蚁获得 300.00元奖励11','恭贺 舌尖上的蚂蚁获得 300.00元奖励22']
export default {
name: 'app',
data () {
return {
news:news,
data:'',
shareData:""
}
},
created(){
this.$vux.loading.hide()


this._wxTool.setShare('','','','','logFlag');



index().then(res=>{
if(res.code == 0){
console.log(res);

this.data = res.data

}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
let accessToken = this._wxTool.getAccessToken();
if(accessToken && accessToken!=''){
accessToken = this._wxTool.getAccessToken()
}else{
accessToken = '';
}
let params = {
accessToken : accessToken,
PrmItemsPerPage:3
}
shareTaskIndexList(params).then(res=>{
if(res.code == 0){
this.shareData = res.data.shareTaskList;
}else{
this.$vux.toast.text(res.msg, 'middle');
}
})
},
methods:{
goTaskDetail(id,shareFlag,endDays,imgUrl,title){
console.log(endDays)
if(endDays<=0){
this.$vux.toast.text('亲~活动已结束，请试试其他活动吧！', 'middle')
return
}
this.$router.push({path:'/taskDetail',query:{shareTaskId:id,shareFlag:shareFlag,imgUrl:imgUrl,title:title}})
},
},
components: {
Swiper,
SwiperItem,
GroupTitle,
XButton,
Divider,
vFooter
}
}



// WEBPACK FOOTER //
// ./src/pages/index/index.vue